export function isMobile(userAgent: string): boolean {
  return /Mobi/.test(userAgent);
}
